<template>
  <div>
    <v-container v-if="singleCheck">
      <div>
        <v-toolbar flat color="light-blue darken-4" class="nav-toolbar">
          <v-toolbar-title class="hidden-xs-only">Drills</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>
          <v-flex xs12 md4 lg3 style="width:100%;">
            <v-select
              v-model="sport"
              :items="sportType"
              :menu-props="{ maxHeight: '400' }"
              label="Sport type"
              multiple
              color="white"
              dark
              outlined
              dense
              hide-details
              class="light-blue darken-4 select_tab_bar"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4 lg3 style="width:100%;">
            <v-select
              v-model="level"
              :items="levels_selected"
              :menu-props="{ maxHeight: '400' }"
              label="Levels"
              multiple
              dark
              outlined
              dense
              hide-details
              class="light-blue darken-4 select_tab_bar"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4 lg3 style="width:100%;">
            <v-text-field
              label="Search"
              v-model="search"
              class="light-blue darken-4 select_tab_bar"
              color="white"
              hide-details
              dark
              outlined
              dense
            >
            </v-text-field
          ></v-flex>
          <v-divider class="mx-2" inset vertical></v-divider>
          <dynamicIcon
            v-model="video"
            :icon="'fas fa-video'"
            :toolTip="'Show Video'"
          />
          <dynamicIcon
            v-model="favorites"
            :icon="'favorite'"
            :toolTip="'Favorites Only'"
          />
          <v-divider class="mx-2" inset vertical></v-divider>

          <v-dialog
            v-model="dialog"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-on="on" v-bind="attrs">
                {{ formTitle }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="form_title">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h3 class="delimiter_text">External Resources</h3>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                        block
                        dark
                        @click="newVideoDialog = !newVideoDialog"
                        color="light-blue darken-4"
                      >
                        Add new video
                      </v-btn>
                      <v-responsive
                        v-if="videoLink && videoLink !== ''"
                        class="mt-4"
                      >
                        <iframe
                          width="100%"
                          height="250"
                          :src="videoLink"
                          frameborder="0"
                          loading="lazy"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowfullscreen
                        ></iframe>
                      </v-responsive>
                    </v-flex>
                    <v-flex xs12>
                      <h3 class="delimiter_text">General Info</h3>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model.trim="editedItem.drillName"
                        label="Drill Name"
                        :counter="50"
                        required
                        outlined
                        color="light-blue darken-4"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        class="hidden-sm-only"
                        v-model.trim="editedItem.drillPurpose"
                        label="Drill Purpose"
                        outlined
                        color="light-blue darken-4"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        class="hidden-sm-only"
                        v-model.trim="editedItem.drillDesc"
                        label="Drill Desc"
                        required
                        outlined
                        color="light-blue darken-4"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <h3 class="delimiter_text">Classification</h3>
                    </v-flex>

                    <v-flex xs12>
                      <v-select
                        v-model="editedItem.status"
                        :items="['Public', 'Private']"
                        label="Status"
                        required
                        outlined
                        color="light-blue darken-4"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <catValueDropDown
                        :outlined="true"
                        label="Equipment"
                        catName="EQUIPMENT"
                        v-model="editedItem.equipment"
                        :multiList="true"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <catValueDropDown
                        :outlined="true"
                        label="Sport type"
                        catName="SPORT_TYPE"
                        v-model="editedItem.sportType"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <catValueDropDown
                        :outlined="true"
                        label="Facility"
                        catName="FACILITY"
                        v-model="editedItem.facility"
                      />
                    </v-flex>
                    <v-flex xs12 sm6>
                      <catValueDropDown
                        :outlined="true"
                        label="Tags"
                        catName="STROKE|TAGS_DRILL"
                        v-model="editedItem.tag"
                        :multiList="true"
                      />
                    </v-flex>
                    <v-flex class="mt-4">
                      <complexityLevelsCheckboxes v-model="editedItem.level" />
                    </v-flex>
                    <v-flex xs12>
                      <h3 class="delimiter_text">Share with</h3>
                    </v-flex>
                    <v-flex>
                      <socialSharing
                        :drillName="this.editedItem.drillName"
                        :drillDesc="this.editedItem.drillDesc"
                        :tags="this.editedItem.tag"
                        :videoUrl="this.editedItem.videoUrl"
                        :sportType="this.editedItem.sportType"
                      />
                    </v-flex>
                    <!-- <v-flex xs12 sm6 md4> -->
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="closeDrill">Close</v-btn>
                <v-btn v-if="user" color="secondary" text @click="actionName"
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!--Add new video dialog-->
          <v-dialog
            v-model="newVideoDialog"
            :retain-focus="false"
            max-width="500px"
          >
            <v-card>
              <v-card-title>
                <span class="form_title">Paste vido link</span>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model.trim="editedItem.videoUrl"
                  label="Resource URL"
                  :rules="urlRules"
                  color="light-blue darken-4"
                >
                </v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn color="success" outlined @click="setVideoUrl">Add</v-btn>
                <v-btn color="error" outlined @click="closeVideoDialog">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!--Loading dialog-->
          <v-dialog
            v-model="loadingDialog"
            :retain-focus="false"
            hide-overlay
            persistent
            width="300"
          >
            <v-card color="light-blue darken-3" dark>
              <v-card-text>
                Please stand by
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-app id="inspire">
          <v-tabs v-model="tab" background-color="secondary" show-arrows>
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab
              v-for="item in this.tabItems"
              :key="item.node.valId"
              :href="'#' + `${item.node.valName}`"
            >
              {{ item.node.valName }}
            </v-tab>
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="subItem in this.tabItems"
                :key="subItem.node.valId"
                :value="subItem.node.valName"
              >
                <v-card class="mx-auto" raised>
                  <v-container>
                    <v-row dense>
                      <v-col
                        v-for="item in drills"
                        :key="item.node.drillName"
                        :cols="12"
                        :sm="4"
                        :md="3"
                        :lg="2"
                      >
                        <v-card shaped>
                          <v-responsive>
                            <td
                              v-if="
                                video &&
                                  item.node.videoUrl &&
                                  item.node.videoUrl.match(new RegExp('embed'))
                              "
                            >
                              <iframe
                                :src="item.node.videoUrl"
                                frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                                scrolling="no"
                                style="overflow:hidden;height:100%;width:100%"
                                height="100%"
                                width="100%"
                              ></iframe>
                            </td>
                            <a
                              v-else-if="
                                item.node.videoUrl !== null &&
                                  item.node.videoUrl !== ''
                              "
                              :href="item.node.videoUrl"
                              target="_blank"
                            >
                              {{ item.node.drillName + " Video" }}</a
                            >
                          </v-responsive>

                          <v-card-text>
                            <v-responsive>
                              <a
                                :href="$route.path + '/' + item.node.drillName"
                                target="_blank"
                              >
                                {{ item.node.drillName + " Card" }}</a
                              >
                              <div class="desc_drill">
                                <p>{{ item.node.drillDesc }}</p>
                                <span
                                  ><strong>Added by: </strong
                                  >{{ item.node.user.userName }}</span
                                >
                              </div>
                            </v-responsive>
                          </v-card-text>
                          <v-chip
                            v-for="(tag, index) in item.node.tag.split(',')"
                            :key="index"
                            :color="getTagColor(item.node.level)"
                            small
                            class="p-2"
                            text-color="white"
                            >{{
                              tag
                                .replace("[", "")
                                .replace("]", "")
                                .replace('\\"', "")
                                .replace('\\"', '"')
                            }}</v-chip
                          >

                          <v-card-actions>
                            <v-btn x-small fab>
                              <v-icon
                                :color="
                                  checkIfDrillLiked(item.node.drillId)
                                    ? 'red'
                                    : 'grey'
                                "
                                class="mr-2"
                                small
                                @click="handleAddFavoriteDrill(item.node)"
                              >
                                favorite
                              </v-icon>
                              <span>{{
                                item.node.favoriteDrillLib.edges.length
                              }}</span>
                            </v-btn>
                            <!--h6 class="ml-5 font-weight-thin">({{item.node.favoriteDrillLib.edges.length}})</h6-->

                            <v-spacer></v-spacer>
                            <!--EDIT BTN-->
                            <v-icon
                              small
                              class="mr-2"
                              @click="editItem(item.node)"
                              :color="'black'"
                            >
                              fas fa-eye
                            </v-icon>
                            <v-tooltip
                              top
                              :disabled="
                                user &&
                                  (user.userId == item.node.user.userId ||
                                    user.role == 'Administrator')
                              "
                            >
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <v-icon
                                    v-model="editedItem.status"
                                    :color="
                                      item.node.status == 'Private'
                                        ? 'grey'
                                        : 'blue'
                                    "
                                    small
                                    class="mr-2"
                                    ><!--@click="handleAddDrill()"               -->
                                    public<!--{{ item.node.status == 'Public' ? "public" : "lock" }}-->
                                  </v-icon>
                                  <v-icon
                                    :disabled="
                                      !(
                                        user &&
                                        (user.userId == item.node.user.userId ||
                                          user.role == 'Administrator')
                                      )
                                    "
                                    small
                                    @click="deleteItem(item.node)"
                                  >
                                    delete
                                  </v-icon>
                                </div>
                              </template>
                              <span>Enabled only for Drill owner</span>
                            </v-tooltip>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-app>
      </div>
    </v-container>
    <drillLibSingleView
      v-else
      :parentEditedItem="singleViewElement[0]"
    ></drillLibSingleView>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import drillLibSingleView from "./drill_lib_single_view.vue";
import catValueDropDown from "../shared/cat_val_dropdown.vue";
import complexityLevelsCheckboxes from "../shared/complexity_levels_checkboxes.vue";
import { randomInteger, hasJsonStructure } from "../../_helpers/index";
import { getTagColor } from "../../mixins/getTagColor.js";
import { getCatValues } from "../../mixins/getCatValues.js";
import socialSharing from "../shared/social_sharing.vue";
//import { urlMetadata } from '../../mixins/urlMetaData.js';
import dynamicIcon from "../shared/dynamic_icon.vue";
import {
  youtubeUrlParser,
  sportTypes,
  validationRules
} from "../../constants/global";
export default {
  components: {
    catValueDropDown,
    complexityLevelsCheckboxes,
    dynamicIcon,
    socialSharing,
    drillLibSingleView
  },
  mixins: [getTagColor, getCatValues], // urlMetadata],
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function() {
      return {
        inner: this.editedItem.drillName
      };
    },
    meta: function() {
      return [
        { property: "og:description", content: this.editedItem.drillDesc },
        { property: "og:image:alt", content: this.editedItem.drillName },
        {
          property: "og:title",
          content:
            this.editedItem.drillName +
            " #" +
            this.editedItem.sportType +
            " #" +
            this.editedItem.tag
        },
        { property: "og:type", content: "video.movie" },
        {
          property: "og:image",
          content:
            "https://img.youtube.com/vi/" + this.videoId + "/maxresdefault.jpg"
        },
        {
          property: "og:url",
          content: "https://portal.sportecos.com" + this.$route.fullPath
        },
        { property: "og:video", content: this.editedItem.videoUrl },
        { property: "og:video:type", content: "video/mp4" },
        { property: "og:video:width", content: "640" },
        { property: "og:video:height", content: "385" }
      ];
    }
  },

  data() {
    return {
      sport: ["SWIMMING"],
      sportType: sportTypes,
      favorites: false,
      catName: "",
      loadingDialog: false,
      urlRules: validationRules.urlRules,
      videoLink: "",
      newVideoDialog: false,
      //      "editedItem.user.userName": "",
      true: true,
      requiredRule: [v => !!v || "Value is required"],
      drillLikedId: "",
      level: ["Begginer", "Junior"],
      drillLiked: false,
      levels_selected: ["Begginer", "Junior", "Advanced", "Unleveled"],
      false: false,
      tab: "FR",
      tag: "",
      drillId: "",
      on: "",
      video: 1,
      "editedItem.status": "Public",
      search: "",
      dialog: false,
      dialogSingle: false,
      menu: false,
      editedIndex: -1,
      editedItem: {
        drillId: "",
        drillName: "",
        drillDesc: "",
        drillPurpose: "",
        videoUrl: "",
        equipment: "",
        sportType: sportTypes,
        facility: "",
        status: "",
        tag: "",
        tab: "",
        level: "",
        "user.userId": "",
        "user.userName": ""
      },
      defaultItem: {
        drillId: "",
        drillName: "",
        drillDesc: "",
        drillPurpose: "",
        videoUrl: "",
        equipment: "",
        sportType: "",
        facility: "",
        status: "",
        tag: "",
        level: "",
        "user.userId": "",
        "user.userName": ""
      },
      singleDrill: {
        drillId: "",
        drillName: "",
        drillDesc: "",
        drillPurpose: "",
        videoUrl: "",
        equipment: "",
        sportType: sportTypes,
        facility: "",
        status: "",
        tag: "",
        tab: "",
        level: "",
        "user.userId": "",
        "user.userName": ""
      },
      singleCheck: true
    };
  },
  created() {
    this.handleGetDrillList();
    this.handleGetFavoriteDrill();

    if (!(Object.entries(this.$route.query).length === 0)) {
      const { tab, sport, drillId } = this.$route.query;
      this.tab = tab;
      this.sport = sport;
      this.drillId = drillId;

      // this.tab = this.categoryList.edges.findIndex((item) => item.node.catName == tab);
    }
  },
  beforeMount() {
    if (!(Object.entries(this.$route.query).length === 0)) {
      this.singleCheck = false;
    }
  },
  computed: {
    ...mapGetters([
      "loading",
      "drillLib",
      "user",
      "favoriteDrillLib",
      "categoryList",
      "categoryValue"
    ]),
    tabItems() {
      if (this.categoryValue.edges && this.drillLib.edges) {
        const drills = this.drillLib.edges.filter(
          el => el.node.sportType === this.sport
        );
        return this.categoryValue.edges
          .filter(cat =>
            cat.node.category.catName.match(new RegExp("STROKE|TAGS_DRILL"))
          )
          .filter(el =>
            drills.filter(el2 => {
              el.node.valName === "ALL" ||
                String(el2.node.tag).includes(el.node.valName);
            })
          );
      } else {
        return [];
      }
    },
    // singleCheck(){
    //  return Object.entries(this.$route.query).length > 0 ? false : true;
    // },

    singleViewElement() {
      if (this.drillLib.edges) {
        return this.drillLib.edges.filter(element => {
          return element.node.drillId == this.$route.query.drillId;
        });
      }
    },
    // classObject: function() {
    //   if (this.editedItem.status == "Public") {
    //     return "lock_open";
    //   } else return "lock";
    // },
    formTitle() {
      return this.editedIndex < 0 ? "New Drill" : "Edit Drill";
    },
    actionName() {
      return this.editedIndex < 0 ? this.addNewDrill : this.editDrill;
    },
    // editedItemNew: function() {
    //   return {
    //     ...this.editedItem,
    //     sportType: this.sport,
    //     tag: this.tab ? this.tab.split(",", 5) : this.tab,
    //     tab: this.tab,
    //   };
    // },
    // binding() {
    //   const binding = {};

    //   if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

    //   return binding;
    // },
    drills() {
      if (this.favorites === false) {
        if (this.drillLib.edges) {
          return this.drillLib.edges.filter(item => {
            if (this.user) {
              return (
                JSON.stringify(this.sport).includes(item.node.sportType) &&
                JSON.stringify(this.level).includes(item.node.level) &&
                JSON.stringify(item.node.tag).includes(this.tab) &&
                //  && (item.node.user.userId === this.user.userId ||
                //   this.user.role === "Administrator")
                (JSON.stringify(item.node.drillName.toUpperCase()).includes(
                  this.search.toUpperCase()
                ) ||
                  this.search === "" ||
                  JSON.stringify(item.node.drillDesc.toUpperCase()).includes(
                    this.search.toUpperCase()
                  ))
              );
            } else {
              return (
                JSON.stringify(this.sport).includes(item.node.sportType) &&
                JSON.stringify(this.level).includes(item.node.level) &&
                JSON.stringify(item.node.tag).includes(this.tab) &&
                (JSON.stringify(item.node.drillName.toUpperCase()).includes(
                  this.search.toUpperCase()
                ) ||
                  this.search === "" ||
                  JSON.stringify(item.node.drillDesc.toUpperCase()).includes(
                    this.search.toUpperCase()
                  ))
              );
            }
          });
        } else {
          return [];
        }
      } else {
        if (this.favoriteDrillLib.edges && this.user) {
          return this.favoriteDrillLib.edges.filter(item => {
            JSON.stringify(this.sport).includes(item.node.sportType) &&
              JSON.stringify(this.level).includes(item.node.level) &&
              JSON.stringify(item.node.tag).includes(this.tab) &&
              (JSON.stringify(item.node.drillName.toUpperCase()).includes(
                this.search.toUpperCase()
              ) ||
                this.search === "" ||
                JSON.stringify(item.node.drillDesc.toUpperCase()).includes(
                  this.search.toUpperCase()
                ));
          });
        } else {
          return [];
        }
      }
    }
  },
  async created() {
    Promise.all([
      this.$store.dispatch("allDrillLib"),
      this.handleFavoriteDrillLib()
    ]);
  },
  watch: {
    dialog(val) {
      if (val) {
        this.updateRouter();
      }
    }
    // sport() {
    //   this.updateRouter();
    // },
  },
  methods: {
    ...mapActions([
      "drillMerge",
      "drillEdit",
      "drillDelete",
      "favoriteDrillLibMerge"
    ]),
    updateRouter() {
      setTimeout(() => {
        this.$router.replace({
          query: {
            sport: this.sport,
            tab: this.tab,
            drillId: this.editedItem.drillId
          }
        });
      }, 300);
    },
    closeDrill() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.closeVideoDialog();
    },
    addNewDrill() {
      this.loadingDialog = true;
      this.drillMerge({
        drillId: Number(randomInteger),
        drillName: String(this.editedItem.drillName),
        drillDesc: String(this.editedItem.drillDesc),
        drillPurpose: String(this.editedItem.drillPurpose),
        videoId: this.getVideoId().toString(),
        videoUrl: String(this.videoLink),
        equipment: JSON.stringify(this.editedItem.equipment),
        sportType: String(this.editedItem.sportType),
        facility: String(this.editedItem.facility),
        status: String(this.editedItem.status),
        tag: JSON.stringify(this.editedItem.tag),
        level: String(this.editedItem.level),
        userId: Number(this.user.userId),
        updateSource: "TEST",
        user: {
          userId: String(this.user.userId),
          userName: String(this.user.userName),
          __typename: "User"
        },
        favoriteDrillLib: { edges: [] }
      })
        .then(() => {
          this.loadingDialog = false;
          this.closeDrill();
          this.$toast.success("Drill has been added");
        })
        .catch(error => {
          this.loadingDialog = false;
          this.closeDrill();
          console.error(error);
        });
    },
    editDrill() {
      this.loadingDialog = true;
      this.drillEdit({
        drillId: Number(this.editedItem.drillId),
        drillName: String(this.editedItem.drillName),
        drillDesc: String(this.editedItem.drillDesc),
        drillPurpose: String(this.editedItem.drillPurpose),
        videoId: this.getVideoId().toString(),
        videoUrl: String(this.videoLink),
        equipment: JSON.stringify(this.editedItem.equipment),
        sportType: String(this.editedItem.sportType),
        facility: String(this.editedItem.facility),
        status: String(this.editedItem.status),
        tag: JSON.stringify(this.editedItem.tag),
        level: String(this.editedItem.level),
        userId: Number(this.user.userId),
        updateSource: "TEST",
        user: {
          userId: String(this.user.userId),
          userName: String(this.user.userName),
          __typename: "User"
        },
        favoriteDrillLib: this.editedItem.favoriteDrillLib
      })
        .then(() => {
          this.loadingDialog = false;
          this.closeDrill();
          this.$toast.success("Drill has been updated");
        })
        .catch(error => {
          this.loadingDialog = false;
          this.closeDrill();
          console.error(error);
        });
    },
    editItem(item) {
      const editedObject = JSON.parse(JSON.stringify(item));

      if (
        hasJsonStructure(editedObject.tag) &&
        hasJsonStructure(editedObject.equipment)
      ) {
        editedObject.equipment = JSON.parse(editedObject.equipment);
        editedObject.tag = JSON.parse(editedObject.tag);
      }
      // * Example below is correct but not needed for buissiness
      // this.editedIndex = this.drillLib.edges.findIndex(x => x.node === item);
      this.editedIndex = 1;
      this.videoLink = editedObject.videoUrl;
      this.editedItem = editedObject;
      this.dialog = true;
      // * Example below also is correct but not needed for buissiness
      // if (this.editedIndex > 0) {
      //   this.videoLink = editedObject.videoUrl;
      //   this.editedItem = editedObject;
      //   this.dialog = true;
      // } else {
      //   this.editedIndex = -1;
      //   console.error(
      //     "No current drill with this index. Error in drill_lib.vue in editItem method"
      //   );
      // }
    },
    closeVideoDialog() {
      this.newVideoDialog = false;
      this.editedItem.videoUrl = "";
      this.videoLink = "";
    },
    handleGetCategoryList() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allCategory", {});
    },
    // handleGetCatValuesList() {
    //   //reach out of Vuex store, fire action that gets athletes
    //   this.$store.dispatch("allCategoryValue", {});
    // },
    handleGetDrillList() {
      //reach out of Vuex store, fire action that gets Drill
      this.$store.dispatch("allDrillLib");
    },
    setVideoUrl() {
      const result = youtubeUrlParser(String(this.editedItem.videoUrl));
      this.videoLink = `https://youtube.com/embed/${result}`;
      this.newVideoDialog = false;
    },
    checkIfDrillLiked(drillId) {
      if (this.user) {
        if (
          Object.entries(this.favoriteDrillLib).length !== 0 &&
          this.favoriteDrillLib.edges.some(fave => fave.node.drillId == drillId)
        ) {
          this.drillLiked = true;

          return true;
        } else {
          this.drillLiked = false;
          return false;
        }
      }
    },
    handleFavoriteDrillLib() {
      if (this.user)
        this.$store.dispatch("allFavoriteDrillLib", {
          userId: this.user.userId
        });
      else this.$store.dispatch("allFavoriteDrillLib");
    },
    handleAddFavoriteDrill(item) {
      //reach out of Vuex store, fire action that gets Drill
      let drillLikedId = 0;
      if (
        this.favoriteDrillLib &&
        this.favoriteDrillLib.edges.some(
          fave => fave.node.drillId == item.drillId
        )
      ) {
        drillLikedId = this.favoriteDrillLib.edges[
          this.favoriteDrillLib.edges.findIndex(
            drill => drill.node.drillId == item.drillId
          )
        ].node.favdrillId;
      }
      this.$store.dispatch("favoriteDrillLibMerge", {
        favdrillId: drillLikedId,
        userId: this.user.userId, // this.drillLiked ? this.user.userId : "",
        drillId: item.drillId,
        user: {
          userId: this.user.userId,
          userName: this.user.userName,
          __typename: "User"
        }
      });
      // const fav = this.favoriteDrillLib.edges.filter(
      //   fave => +fave.node.drillId == +item.drillId
      // )

      // if (fav.length > 0) {
      //   console.log(fav[0].node.favdrillId);
      //   this.favoriteDrillLibMerge({
      //     favdrillId: parseInt(fav[0].node.favdrillId, 10),
      //     userId: parseInt(this.user.userId, 10),
      //     drillId: parseInt(item.drillId, 10)
      //   })
      // } else {
      //   this.favoriteDrillLibMerge({
      //     userId: parseInt(this.user.userId, 10),
      //     drillId: parseInt(item.drillId, 10)
      //   })
      // }
    },
    handleToggleFavorite(item) {
      if (this.drillLiked) {
        this.handleRemoveFavoriteDrill(item);
      } else {
        this.handleAddFavoriteDrill(item);
      }
    },

    closeVideoDialog() {
      this.newVideoDialog = false;
      this.editedItem.videoUrl = "";
      this.videoLink = "";
    },
    getVideoId() {
      const splitedLink = this.videoLink.toString().split("/");
      return splitedLink[splitedLink.length - 1];
    },
    IsValidJSONString(text) {
      if (typeof text !== "string") {
        return false;
      }
      try {
        JSON.parse(text);
        return true;
      } catch (error) {
        return false;
      }
    },

    handleDeleteDrill() {
      // if (this.$ref.dialog.validate()) {
      // check for any rules validations on the form

      this.$store.dispatch("drillDelete", {
        drillId: this.editedItem.drillId
      });
      //}
    },
    deleteItem(item) {
      const index = this.handleGetDrillList.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
        // this.handleGetAthleteList.splice(index, 1);
        this.handleDeleteDrill(index);
    }
  }
};
</script>
<style scoped>
@media screen and (max-width: 900px) {
  .nav-toolbar >>> .v-toolbar__content {
    flex-wrap: wrap;
  }
  .v-toolbar,
  .nav-toolbar >>> .v-toolbar__content {
    height: auto !important;
  }
  .select_tab_bar {
    margin-bottom: 10px;
  }
}
.desc_drill {
  font-size: 12px;
  margin-top: 5px;
}
.desc_drill p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
}
.desc_drill strong {
  color: dodgerblue;
}
</style>
